module.exports = __webpack_public_path__ + "img/Fire.f4fc349f.png";